import React, { Component } from "react";
import PubSub from 'pubsub-js'
import "./schedule.less";
import { meshLog, SPGet} from "../../utils/spUtils";
import {SET_LIGHT_DIALOG_SHOW, SET_ASSOCIATE_DIALOG_SHOW, SET_LIGHT_DIALOG_HIDE, SET_ASSOCIATE_DIALOG_HIDE, SET_Emergency_DIALOG_SHOW, SET_Emergency_DIALOG_HIDE, SCHEDULE_show_setGroup} from "../../const/infoConst"
import {SCHEDULE_show_detail} from "../../const/infoConst"
import ScheduleManagePage from "./scheduleManagePage/scheduleManagePage";
import CreateSchePage from "./createSchePage/createSchePage";
import SetGroupPage from "./setGroupPage/setGroupPage";
import SetLightDialog from "./setLightDialog/setLightDialog";
import SetAssociateDialog from "./setAssociateDialog/setAssociateDialog";
import SetEmergencyDialog from "./setEmergencyDialog/setEmergencyDialog";
import DesignView from "../admin/designView/designView";


export default class Schedule extends Component {
  constructor(a) {
    super(a);
    this.state = {
      showLightDiaolg: 'none',
      showAssociateDiaolg: 'hidden',
      showEmerDiaolg: 'hidden',
      showSchedulePage: 'none', //'visible'
      showSetgroupPage: 'hidden', //'visible'
    }
  }

  componentDidMount() {

    //广播弹窗--显示
    PubSub.subscribe(SET_LIGHT_DIALOG_SHOW, (msg, index) => {
        this.setState({
          showLightDiaolg: 'flex',
        })
    })
    PubSub.subscribe(SET_ASSOCIATE_DIALOG_SHOW, (msg, index) => {
        this.setState({
          showAssociateDiaolg: 'visible',
        })
    })
    PubSub.subscribe(SET_Emergency_DIALOG_SHOW, (msg, index) => {
        this.setState({
          showEmerDiaolg: 'visible',
        })
    })

    //广播弹窗--隐藏
    PubSub.subscribe(SET_LIGHT_DIALOG_HIDE, (msg, index) => {
        this.setState({
          showLightDiaolg: 'none',
        })
    })
    PubSub.subscribe(SET_ASSOCIATE_DIALOG_HIDE, (msg, index) => {
        this.setState({
          showAssociateDiaolg: 'hidden',
        })
    })
    PubSub.subscribe(SET_Emergency_DIALOG_HIDE, (msg, index) => {
        this.setState({
          showEmerDiaolg: 'hidden',
        })
    })

  }


  //侧边栏
  getDataFromManage=(msg)=>{
      if(msg==SCHEDULE_show_detail){
          this.setState({
            showSchedulePage: 'flex', 
          });
      }else if(msg==SCHEDULE_show_setGroup){
          this.setState({
            showSetgroupPage: 'visible', 
          });
      }else{
          this.setState({
            showSchedulePage: 'none', 
            showSetgroupPage: 'hidden', 
          });
      }
  }
  
  getDataFromCreateSche=(msg)=>{
      this.setState({
        showSchedulePage: 'none', 
      });
  }

  getDataFromSetGroup=(msg)=>{
      this.setState({
        showSetgroupPage: 'hidden', 
      });
  }


  componentWillUnmount() {

  }

  render(){
    return(
      <div className="schedule_container">
        {/* 左侧边栏 */}
        <div className="sidebar1"><ScheduleManagePage onDataToParent={this.getDataFromManage}/></div>
        
        {/* 右侧平面图区域 */}
        <div className="content">
          <div className="bg-image" ><DesignView /></div>
          <div className="sidebar2" style={{display: this.state.showSchedulePage, top:"100px", height:"750px" }}><CreateSchePage onDataToParent={this.getDataFromCreateSche}/></div>
          <div className="sidebar2" style={{visibility: this.state.showSetgroupPage, top:"150px", height:"500px" }}><SetGroupPage onDataToParent={this.getDataFromSetGroup}/></div>
        </div>

        <div className="sche_dialog" style={{display: this.state.showLightDiaolg }}><SetLightDialog /></div>
        <div className="sche_dialog" style={{visibility: this.state.showAssociateDiaolg }}><SetAssociateDialog /></div>
        <div className="sche_dialog" style={{visibility: this.state.showEmerDiaolg }}><SetEmergencyDialog /></div>
      </div>
    )
  }
}